import React from 'react';

import { Flex } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { Avatar } from 'uiToolkitV1/Avatar';

// content will be a react component
export default function ImageWithContent({
  imageProps = { padding: '2px' },
  content,
  leftGutter,
  rightGutter,
  bottomGutter,
  topGutter,
  align = 'center',
  isLoggedInEmployeeComment,
  styleType,
  avatarSize = null,
}) {
  const { src } = imageProps;
  return (
    <Container
      topGutter={topGutter}
      leftGutter={leftGutter}
      rightGutter={rightGutter}
      bottomGutter={bottomGutter}
      align={align}
      styleType={styleType}
    >
      {isLoggedInEmployeeComment && styleType === 'chat' ? (
        <>
          <ContentContainer
            // styleType={styleType}
            isLoggedInEmployeeComment={isLoggedInEmployeeComment}
          >
            {content}
          </ContentContainer>
          <ImageContainer {...imageProps} isLoggedInEmployeeComment={isLoggedInEmployeeComment}>
            <Flex sx={{ marginRight: '16px' }}>
              <Avatar src={src} size={avatarSize} />
            </Flex>
          </ImageContainer>
        </>
      ) : (
        <>
          <ImageContainer {...imageProps} rightAligned={false}>
            <Flex sx={{ marginRight: '16px' }}>
              <Avatar src={src} size={avatarSize} />
            </Flex>
          </ImageContainer>
          <ContentContainer styleType={styleType} rightAligned={false}>
            {content}
          </ContentContainer>
        </>
      )}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  align-items: ${(props) => props.align};
  padding: 8px 12px;
  margin-top: 12px;
`;

const ImageContainer = styled.div``;

const ContentContainer = styled.div`
  width: 100%;
  /* Content container overshoots containing flex container due to min-width: auto */
  min-width: 0;
  ${(props) =>
    props.styleType === 'chat' &&
    css`
      width: auto;
      max-width: calc(85% - 85px);
    `}
  }
  ${(props) =>
    props.isLoggedInEmployeeComment &&
    css`
      margin-left: auto;
    `}
`;

ImageWithContent.propTypes = {
  content: PropTypes.element,
};
